export const SAVE_REQUIRED_FIELDS =
  '/api/syndication/save-additional-required-fields';
export const GET_ADDITIONAL_REQUIRED_FIELDS_GRID =
  '/api/syndication/get-additional-required-fields-grid';

export const DELETE_ADDITIONAL_REQUIRED_FIELDS =
  '/api/syndication/delete-additional-required-fields';
export const GET_REQUIRED_FIELD_SHORT_DETAIL =
  '/api/syndication/get-additional-required-field-short-detail';
